import { PointsTable } from "./table/PointsTable";
import { Pagination } from "../../../../components/Pagination"
import { UsersListLoading } from "../../Reviews/Review/users-list/components/loading/UsersListLoading";

const PointsModalForm = ({
  setOpenPointsModal,
  pointsHistory,
  page,
  pageSize,
  setPage,
  setPageSize,
  total,
  isLoading,
  currentUser,
  haveAccess
}) => {


  return (
    <>
      <div className="kt_body">
        <PointsTable points={pointsHistory} haveAccess={haveAccess} currentUser={currentUser} />
        <Pagination
          page={page}
          setPage={setPage}
          pageSize={pageSize}
          setPageSize={setPageSize}
          total={total || 0}
          pageSizeOptions={[10, 20, 50, 100]}
        />
        {isLoading && <UsersListLoading />}
        <div className="d-flex gap-2 justify-content-center">
          <button
            type="button"
            className="btn mt-4 w-auto btn-primary"
            onClick={() => setOpenPointsModal(false)}
            style={{
              color: "#fff",
              height: "46px",
              fontWeight: "700",
            }}
          >
            Go Back
          </button>
        </div>
      </div>
    </>
  );
};

export { PointsModalForm };
